import { Box, Button } from '@mui/material';
import { FC, useEffect } from 'react';
import type { ConvertFlowCta as IConvertFlowCta } from '@/types/generated';
import { IglobalThis } from '@shared-components/types';
const ConvertFlowCta: FC<IConvertFlowCta> = ({
  ctaId,
  buttonLabel,
  embedId,
  websiteId
}) => {
  useEffect(() => {
    // 2. Force ConvertFlow to scan the DOM for this new embed block as soon as it mounts
    if (typeof globalThis !== 'undefined' && (globalThis as IglobalThis).convertflow) {
      (globalThis as IglobalThis).convertflow?.start();
    }
  }, []);
  return <Box component="section" display="flex" flexDirection="column" justifyContent="center" alignItems="center" data-sentry-element="Box" data-sentry-component="ConvertFlowCta" data-sentry-source-file="ConvertFlowCta.tsx">
			{/* ConvertFlow will attach click handlers to elements with this class pattern */}
			<Button className={`cta-${ctaId}-trigger`} variant="primaryAccent1" data-sentry-element="Button" data-sentry-source-file="ConvertFlowCta.tsx">
				{buttonLabel}
			</Button>
			<div className={`cf-cta-snippet cta${embedId}`} data-website-id={websiteId} data-cta-id={embedId} />
		</Box>;
};
export default ConvertFlowCta;